var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOauthGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_155_47)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_155_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.726 11.7152C22.726 10.7729 22.6495 10.0853 22.484 9.37219H11.7239V13.6253H18.0398C17.9125 14.6822 17.2249 16.2739 15.6968 17.3435L15.6754 17.4859L19.0776 20.1215L19.3133 20.1451C21.478 18.1458 22.726 15.2043 22.726 11.7152Z",
    fill: "#EDFFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7239 22.921C14.8182 22.921 17.4159 21.9023 19.3133 20.1451L15.6969 17.3435C14.7291 18.0184 13.4302 18.4896 11.7239 18.4896C8.69327 18.4896 6.12104 16.4904 5.20411 13.7272L5.06971 13.7386L1.5321 16.4764L1.48584 16.605C3.37044 20.3487 7.24155 22.921 11.7239 22.921Z",
    fill: "#D8F0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.204 13.7272C4.96206 13.0141 4.82205 12.25 4.82205 11.4605C4.82205 10.671 4.96207 9.90698 5.19128 9.1939L5.18487 9.04203L1.60292 6.26025L1.48573 6.316C0.708997 7.86955 0.263306 9.61413 0.263306 11.4605C0.263306 13.3069 0.708997 15.0514 1.48573 16.605L5.204 13.7272Z",
    fill: "#D8FFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7239 4.43136C13.8759 4.43136 15.3275 5.36093 16.1553 6.13775L19.3897 2.97973C17.4032 1.13332 14.8182 0 11.7239 0C7.24155 0 3.37044 2.57223 1.48584 6.31596L5.19139 9.19386C6.12104 6.43061 8.69327 4.43136 11.7239 4.43136Z",
    fill: "#B5D7C9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_155_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOauthGoogle);
export default __webpack_public_path__ + "static/media/oauth-google.88da9d5d3b1a5153eb3d4e3739fa24c2.svg";
export { ForwardRef as ReactComponent };